import { format } from 'date-fns';
import { uk } from 'date-fns/locale';

interface DateRange {
  from: string | null;
  to: string | null;
}

/**
 * Formats a date range JSON string into a user-friendly format
 * @param dateRangeStr JSON string representing a date range
 * @returns Formatted date range string or the original string if not a valid date range
 */
export const formatDateRangeForDisplay = (dateRangeStr: string): string => {
  try {
    // Try to parse the string as JSON
    const dateRange = JSON.parse(dateRangeStr) as DateRange;

    // Check if it has the expected structure
    if (dateRange && (dateRange.from || dateRange.to)) {
      if (dateRange.from && dateRange.to) {
        // Both dates are present
        const fromDate = new Date(dateRange.from);
        const toDate = new Date(dateRange.to);
        return `${format(fromDate, 'dd.MM.yyyy', { locale: uk })} - ${format(toDate, 'dd.MM.yyyy', { locale: uk })}`;
      } else if (dateRange.from) {
        // Only from date is present
        const fromDate = new Date(dateRange.from);
        return `від ${format(fromDate, 'dd.MM.yyyy', { locale: uk })}`;
      } else if (dateRange.to) {
        // Only to date is present
        const toDate = new Date(dateRange.to);
        return `до ${format(toDate, 'dd.MM.yyyy', { locale: uk })}`;
      }
    }

    // Not a valid date range, return the original string
    return dateRangeStr;
  } catch (e) {
    // If parsing fails, return the original string
    return dateRangeStr;
  }
};
